//imports
import React, { useState, useEffect } from "react";
import {
  Grid,
  Box,
  TextField,
  FormControl, Button,
  Stack, Typography,
  Paper,
  Breadcrumbs,
  Link,
  AppBar,
  Snackbar,
  Alert,
  InputAdornment,
  Autocomplete,
  useMediaQuery
} from "@mui/material";
import { Tabs, Tab } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AddToolbar from "../../components/common/AddToolbar";
import Navbar from "../../components/common/Navbar";
import { useStyles } from "../../assets/styles/Theme";
import {
  externalgetApi,
  externalpostApi
} from "../../services/external/externalApis";
import {
  SETTINGS_API_21,
  SETTINGS_API_16,
  images_01, SETTINGS_API_17
} from "../../api/ApiModel";
import ImageCropper from "../../components/common/ImageCropper";
import {
  CON_DEF_WAITING_TIME,
  CON_STATUS_ACTIVE,
  CON_MAX_FILESIZE_ITEMIMG,
  CON_MENUICON_WIDTH,
  CON_MENUICON_HEIGHT
} from "../../utils/sys/Constants";
import { useSelector } from "react-redux";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";
import {
  IMAGEBASEURL
} from "../../config/Config";

import useDisableButton from "../../hooks/useDisableButton";

const SetupPromotion = () => {
  //hooks
  const navigate = useNavigate();
  const theme = useTheme();
  const styles = useStyles(theme);

  const SYS_USER = useSelector((state) => state.user) || {};
  const { PROMOCODE, COMPCODE, LOCCODE, RESTCODE, USERNAME, BUSINESSTYPECODE } =
    SYS_USER.USER_PARAM || {};
  const [data2, setData2] = useState([]);
  const [data3, setData3] = useState([]);
  const [error, setError] = useState({});
  const [menucatCode, setMenucatCode] = useState(null); // Store MENUCATCODE from API
  const [isLoading, setIsLoading] = useState(true); // To manage loading
  const { disabled, handleDisable } = useDisableButton(CON_DEF_WAITING_TIME);
 const [tabIndex, setTabIndex] = useState(0);
  const [filteredData, setFilteredData] = useState([]); // To store filtered data
  const location = useLocation();
  const { selectedItem } = location.state || {};
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [openErrorSnackbar, setOpenErrorSnackbar] = useState(false);
  const [images, setImages] = useState([]);
  const [selectedImageUrl, setSelectedImageUrl] = useState("");
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const isEdit = location.state?.actionText === "Edit";
  const [imageSrc, setImageSrc] = useState(
 // Default image URL
  );
  const [filePath, setFilePath] = useState("");
  const [croppedImg, setCroppedImg] = useState("");
  const [selectedItemDetails, setSelectedItemDetails] = useState({
    PROMOCODE: "",
    MENUCODE: "",

    FROMDATE: "",
    VALIDDAYS: "",
IMAGEPATH: "",
    REMARK: "",
    BYTEARRAY: "",
  });

  const isSmallScreen = useMediaQuery("(max-width:600px)"); // Adjust breakpoint as needed
  const marginLeftImage = isSmallScreen
    ? selectedImageUrl
      ? 60
      : 60
    : selectedImageUrl
    ? 115
    : 95;

  useEffect(() => {
    if (selectedItem) {
      setSelectedItemDetails({
        MENUCODE: String(selectedItem.MENUCODE),

        FROMDATE: String(selectedItem.FROMDATE),
        VALIDDAYS: calculateValidDays(
          selectedItem.FROMDATE,
          selectedItem.TODATE
        ),
        // Ensure this is correct
        REMARK: String(selectedItem.REMARK),
       IMAGEPATH: String(selectedItem.IMAGEPATH),
        BYTEARRAY: selectedItem.BYTEARRAY,
      });
     
    }
  }, [selectedItem]);


  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // Clear the error for the specific field when the user starts typing
    if (error[name]) {
      setError((prevError) => ({
        ...prevError,
        [name]: "",
      }));
    }

    // Update the state for input values
    setSelectedItemDetails((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));
  };

  const handleImageClick = async (image) => {
    const imageUrl = `${IMAGEBASEURL}${image.IMAGEPATH.replace("~", "")}`;
    setSelectedImageUrl(imageUrl);
    console.log("Selected Image URL:", `${imageUrl}`);
  };

  const gotToView = () => {
    navigate("/vsetupPromotion");
  };
  const handleCroppedImage = (img) => {
    setCroppedImg(img);

    console.log("Received cropped image from child:", img);
  };

  const handleDateChange = (date, name) => {
    const formattedDate = date ? date.format("YYYY-MM-DD") : "";

    // Clear the error for the specific date field when a valid date is selected
    if (error[name] && formattedDate) {
      setError((prevErrors) => ({ ...prevErrors, [name]: "" }));
    }

    setSelectedItemDetails((prevState) => ({
      ...prevState,
      [name]: formattedDate,
    }));
  };

  const handledataChange = (value, text) => {
    setSelectedItemDetails((prevState) => ({
      ...prevState,
      [text]: String(value),
    }));
  };



  useEffect(() => {
    fetchData();
  }, []); // Ensure this runs when these dependencies change
  useEffect(() => {
    fetchImages();

    fetchDatalist();
  }, []);
  const fetchData = async () => {
    try {
      const result = await externalgetApi(SETTINGS_API_17, "get", {
        COMPCODE,
        LOCCODE,
        RESTCODE,
      });

      console.log("thusaa", result); // Log result to verify the structure

      // Check if result is an array and has at least one item
      if (Array.isArray(result) && result.length > 0) {
        const menuCat = result[0]; // Get the first item in the array
        if (menuCat.MENUCATCODE) {
          setMenucatCode(menuCat.MENUCATCODE); // Store MENUCATCODE in state
        } else {
          console.log("MENUCATCODE not found in the first item of the array.");
        }
      } else {
        console.log("No data found or result is not an array.");
      }

      setData3(result);
      setFilteredData(result);
    } catch (err) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  };

  //post api
  const handleConfirmClick = async () => {
    handleDisable();
    const { MENUNAME, FROMDATE, IMAGEPATH, REMARK, MENUCODE, VALIDDAYS } =
      selectedItemDetails;

    const requiredFields = [
      { name: "FROMDATE", value: FROMDATE, label: "Start Date" },
      { name: "MENUCODE", value: MENUCODE, label: "Menu Name" },

      { name: "VALIDDAYS", value: VALIDDAYS, label: "Valid Days" },
    ];

    const missingRequiredFields = requiredFields.filter(
      (field) => !field.value
    );
    if (missingRequiredFields.length > 0) {
      const newError = {};
      missingRequiredFields.forEach((field) => {
        newError[field.name] = `${field.label} is required.`;
      });

      setError(newError); // Set the error state
      const missingFieldLabels = missingRequiredFields
        .map((field) => field.label)
        .join(", ");
      const errorMessage = `Please Fill All the Required Fields.`;

      // Set error only during submission
      setSnackbarMessage(errorMessage); // Show snackbar with missing fields
      setOpenErrorSnackbar(true);
      return; // Prevent form submission
    }
    const promocode = selectedItem ? String(selectedItem.PROMOCODE || "") : "";

    // Static values including dynamic MENUCATCODE from state
    const staticValues = {
      COMPCODE,
      LOCCODE,
      RESTCODE,
      BUSINESSTYPECODE,
      MENUCATCODE: String(menucatCode), // Use the dynamically fetched MENUCATCODE
      STS: CON_STATUS_ACTIVE,
      ENUSER: USERNAME,
      IMAGEPATH: selectedImageUrl || selectedItemDetails.IMAGEPATH ,
   
    };

    const payload = {
      ...staticValues,
      ...selectedItemDetails,
      PROMOCODE: promocode,
      BYTEARRAY: croppedImg.length > 0 ? String(croppedImg.split(",")[1]) : "",
    };

    try {
      console.log("Payload for API call:", payload);
      const responseData = await externalpostApi(SETTINGS_API_21, payload);
      console.log("Success:", responseData);
      setOpenSnackbar(true);
      setSnackbarMessage("Promotion saved successfully!");
      setSelectedItemDetails({
        MENUCODE: "",
        FROMDATE: "",
        IMAGEPATH: setSelectedImageUrl(""),
        VALIDDAYS: "",
        REMARK: "",
        BYTEARRAY:""

      });
    } catch (error) {
      console.error("Error:", error);
      setSnackbarMessage("An error occurred while saving the promotion.");
      setOpenErrorSnackbar(true);
    }
    setTimeout(() => {
      navigate("/vsetupPromotion");
    }, 2000);
  };

  const handleClearClick = () => {
    setSelectedItemDetails({
      MENUNAME: "",
      FROMDATE: "",

      VALIDDAYS: "",
      REMARK: "",
    });
    setSelectedImageUrl("");
  };

  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  };

  const handleErrorSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorSnackbar(false); // Reset the snackbar state
  };



  //edited by pipuni nov 5
  const fetchDatalist = async () => {
    try {
      const result = await externalgetApi(SETTINGS_API_16, "get", {
        COMPCODE,
        LOCCODE,
        RESTCODE,
      });

      setData2(result);
    } catch (err) {
      setError(err);
      setOpenErrorSnackbar(true);
    }
  };

  const fetchImages = async () => {
    try {
      const result = await externalgetApi(images_01, "get", {
        BUSINESSTYPECODE,
      });
      if (Array.isArray(result)) {
        setImages(result);
      } else {
        console.error("Expected an array, got:", result);
        setImages([]); // Set an empty array to avoid errors
      }
    } catch (err) {
      console.error("Error fetching image options:", err);
      setError(true);
    }
  };
  const calculateValidDays = (fromDate, toDate) => {
    if (fromDate && toDate) {
      const diffInDays = dayjs(toDate).diff(dayjs(fromDate), "day"); // +1 to include the start date
      return diffInDays > 0 ? diffInDays : "";
    }
    return "";
  };

  return (
    <div>
      <Navbar />

      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs}
                position="fixed"
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="none">Home</Link>
                <Link underline="none">Promotions</Link>
                <Link underline="none">Setup Promotion</Link>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12} md={6}>
              <Stack
                sx={{
                  ...styles.AI_fixedStack,
                  direction: "row",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  onClick={gotToView}
                  variant="contained"
                  startIcon={<ArrowBackIcon />}
                  sx={{
                    background: theme.palette.primary.main,
                    color: theme.palette.text.buttontxt,
                    textTransform: "capitalize",
                    letterSpacing: "1px",
                    width: "80px",
                  }}
                >
                  Back
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </AppBar>

      <Box sx={styles.AI_AddStyledBox}>
        <AddToolbar
          label={{ name: isEdit ? "Edit  Promotion" : "Add Promotion" }}
        />
        <Grid container spacing={2} sx={styles.AI_container}>
          <Grid item spacing={2} xs={12} sm={12} md={6} lg={6}>
            <Grid item xs={12} sm={12}>
              <FormControl fullWidth size="small">
                <Autocomplete
                  options={data2}
                  required
                  getOptionLabel={(option) => option.MENUNAME}
                  value={
                    data2.find(
                      (item) => item.MENUCODE == selectedItemDetails.MENUCODE
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    handleInputChange({
                      target: {
                        name: "MENUNAME",
                        value: newValue ? newValue.MENUNAME : "",
                      },
                    });
                    handleInputChange({
                      target: {
                        name: "MENUCODE",
                        value: newValue ? String(newValue.MENUCODE) : "",
                      },
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      error={Boolean(error.MENUCODE)} // Ensure the error boolean is correctly passed
                      helperText={error.MENUCODE || ""} // Display the helper text if an error exists
                      label="Promotion Item"
                      variant="outlined"
                      size="small"
                      required
                    />
                  )}
                  ListboxProps={{
                    style: {
                      maxHeight: 150,
                      backgroundColor: theme.palette.background.paper,
                    },
                  }}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={12} md={12} lg={12} mt={2}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label={
                    <span>
                      Start Date<span style={{ color: "red" }}> *</span>
                    </span>
                  }
                  value={
                    selectedItemDetails.FROMDATE
                      ? dayjs(selectedItemDetails.FROMDATE)
                      : null
                  }
                  onChange={(newValue) =>
                    handleDateChange(newValue, "FROMDATE")
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      error={!!error.FROMDATE}
                      helperText={
                        error.FROMDATE || "Please select a valid start date."
                      } // Updated error message
                    />
                  )}
                  slotProps={{
                    textField: {
                      error: Boolean(error.FROMDATE), // Pass error here
                      helperText: error.FROMDATE,
                      sx: {
                        width: "100%",
                        "& .MuiInputLabel-root": {
                          mt: "-0.5rem",
                          fontSize: "15px",
                        },
                        "& .MuiInputBase-root": {
                          height: "40px",
                        },
                        "& .MuiInputAdornment-root .MuiIconButton-root": {
                          color: theme.palette.primary.main, // Change icon color here
                        },
                      },
                    },
                    popper: {
                      sx: {
                        "& .MuiPaper-root": {
                          backgroundColor: theme.palette.background.default, // Background color of the popper
                          boxShadow: "none", // Remove box shadow if needed
                        },
                      },
                    },
                  }}
                />
              </LocalizationProvider>
            </Grid>

            <Grid item xs={12} sm={12} mt={2}>
              <TextField
                label="Valid Days"
                fullWidth
                size="small"
                name="VALIDDAYS"
                value={selectedItemDetails.VALIDDAYS}
                onChange={handleInputChange}
                variant="outlined"
                error={!!error.VALIDDAYS} // Show error state
                helperText={error.VALIDDAYS} // Display error message
                required
              />
            </Grid>
          </Grid>
          <Grid item spacing={2} xs={12} sm={12} md={6} lg={6}>
            <Grid item xs={12} sm={12}>
              <TextField
                label="Remark"
                size="small"
                fullWidth
                variant="outlined"
                name="REMARK"
                value={selectedItemDetails.REMARK}
                onChange={handleInputChange}
                error={!!error.REMARK}
                helperText={error.REMARK}
                autoComplete="off"
              />
            </Grid>
       
            <Grid container spacing={2} mt={2}>
  <Grid item xs={12}>
    <Tabs
      value={tabIndex}
      onChange={(e, newIndex) => setTabIndex(newIndex)}
    >
      <Tab label="Upload Image" />
    </Tabs>
  </Grid>
  <Grid item xs={12} sm={8}>
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6}>
        <ImageCropper
          onCropComplete={handleCroppedImage}
          FIXED_WIDTH={CON_MENUICON_WIDTH}
          FIXED_HEIGHT={CON_MENUICON_HEIGHT}
          MAX_FILESIZE={CON_MAX_FILESIZE_ITEMIMG}
          setSnackbarMessage={setSnackbarMessage}
          setOpenErrorSnackbar={setOpenErrorSnackbar}
          setMatchingItem={setSelectedItemDetails}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        {croppedImg && (
          <Box display="flex" flexDirection="column" alignItems="center">
            <Typography variant="subtitle1" gutterBottom>
              Preview:
            </Typography>
            <Paper elevation={3} sx={{ padding: 2 }}>
              <img
                src={croppedImg}
                alt="Cropped Preview"
                style={{ width: 150, height: 150, objectFit: "cover" }}
              />
            </Paper>
          </Box>
        )}
      </Grid>
    </Grid>
  </Grid>
  {/* Image Display Section */}
  <Grid item xs={12} sm={4}>
  <Box
    display="flex"
    alignItems="center"
    justifyContent="center"
    height="100%"
  >
    {!croppedImg && selectedItemDetails?.IMAGEPATH && (
      <img
        src={selectedItemDetails.IMAGEPATH}
        alt=""
        style={{
          maxWidth: "100%",
          maxHeight: "150px",
          objectFit: "contain",
          cursor: "pointer",
        }}
      />
    )}
  </Box>
</Grid>

  {/* Image Cropper and Preview Section */}

</Grid>

          </Grid>
        </Grid>
        <Stack
          direction="row"
          spacing={2}
          m={1}
          justifyContent="flex-end"
          padding={1}
        >
          <Button
            variant="outlined"
            sx={styles.AI_button1}
            onClick={handleClearClick}
          >
            Clear
          </Button>
          <Button
            variant="contained"
            sx={styles.AI_button2}
            onClick={handleConfirmClick}
            disabled={disabled}
          >
            {isEdit ? "Modify" : "Confirm"}
          </Button>
        </Stack>
      </Box>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        sx={{ top: "10%", right: "10%" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity="success"
          sx={{ width: "100%" }}
        >
          {isEdit ? "Updated Successfully!" : " Created Successfully!"}
        </Alert>
      </Snackbar>

      <Snackbar
        open={openErrorSnackbar}
        message={snackbarMessage}
        autoHideDuration={6000}
        onClose={handleErrorSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        sx={{ top: "10%", right: "10%" }}
      >
        <Alert
          onClose={handleErrorSnackbarClose}
          severity="error"
          sx={{ width: "100%" }}
        >
          {snackbarMessage || "Please fill out all fields before submitting."}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default SetupPromotion;
